module.exports = ".container {\n  max-width: 40em;\n}"